function popupRules(app) {
  return {
    areaName: [
      {
        max: 50,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.popup.system.area.label.areaName'),
          length: 50
        }),
        trigger: 'blur'
      }
    ]
  }
}

export default {
  popupRules: popupRules
}
